/**
 * AppEntry.js
 * Central Entry Point for GeoPST Map Application.
 * Consolidates all modules into a single dependency graph for Parcel 2.
 */

// 1. Core Map Initialization (Exports global map & view)
import './Map';

// 2. UI Components & Base Controls
import './BasemapSwitcher';
import './Layers';
import './Scale';
import './Coordinates';

// 3. Operational Tools (Identify & Search)
import './Identify';
import './Search';
import './TopSearch';

// 4. Analysis & Interaction Tools
import './Measure';
import './Draw';
import './Snapping';
import './NotePin';
import './SharePin';

// 5. Geolocation & Navigation
import './Geolocation';
import './Routing';
import './FieldGuidance';
import './GoToCoordinates';
import './RotateMap';

// 6. Data Management & Utilities
import './FileLoader';
import './Report';
import './ShareLocation';
import './CoordinateConverter';

// 7. Feedback & Hubs
import './ToolsHub';

// 8. Onboarding & Overlays
import './IntroTour';
import './Consent Modal';

// 9. Sidebars & Panels
import './BottomSheet';
import './UserManagement';
